<!--
  @author:chen.hao
  @time:2019/01/03
  @disc:动态级联框
  type:industry(行业分类) product(产品分类)
  level:级联层级默认为3
 -->

<template>
  <el-cascader v-bind="$attrs"
               v-on="$listeners"
               v-model="currentValue"
               :options="option"
               :selectAll="selectAll"
               :props="defaultProps"
               @change="handleChange"
               ref="cascader"
               @active-item-change="handleItemChange"></el-cascader>
</template>

<script>

import { mapActions } from 'vuex'
export default {
  name: 'ajaxCascader',
  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {},
    type: {},
    extraParams: {},
    level: {
      default: 4
    },
    selectAll: {
      default: false
    }
  },

  data () {
    return {
      option: [],
      typeChange: false,
      currentValue: [],
      currentLabel: []
    }
  },

  computed: {
    action () {
      switch (this.type) {
        case 'product':
          return this.getCategoryTree
        case 'industry':
          return this.getIndustry
      }
    },

    defaultProps () {
      switch (this.type) {
        case 'product':
          return { value: 'id', label: 'categoryName' }
        case 'industry':
          return { value: 'id', label: 'name' }
      }
    }

  },

  methods: {

    ...mapActions(['getCategoryTree', 'getIndustry']),
    // 加载二级三级分类
    handleItemChange (val) {
      const level = val.length
      return new Promise((resolve, reject) => {
        this.option.forEach(item => {
          if (item.id === val[0]) {
            // 查询二级
            if (level === 1 && (item.children.length === 0 || this.typeChange)) {
              this.action({ id: val[0], ...this.extraParams }).then(res => {
                if (res) {
                  if (this.selectAll) {
                    res.unshift({
                      id: '1',
                      name: '全部'
                    })
                  }
                  item.children = res.map(resItem => {
                    let obj = { ...resItem }
                    if (this.level > 2) {
                      obj.children = []
                    }
                    // if (resItem.hasChildren === 1) {
                    //   obj.children = []
                    // }
                    return obj
                  })
                } else {
                  item.children = []
                }
                resolve()
              })
            }

            // 查询三级
            if (level === 2) {
              item.children.forEach(subItem => {
                if (subItem.id === val[1] && subItem.children.length === 0) {
                  this.action({ id: val[1], ...this.extraParams }).then(res => {
                    if (res) {
                      if (this.selectAll) {
                        res.unshift({
                          id: '1',
                          name: '全部'
                        })
                      }
                      subItem.children = res.map(resItem => {
                        let obj = { ...resItem }
                        // if (this.level > 3) {
                        //   obj.children = []
                        // }
                        if (resItem.hasChildren === 1) {
                          obj.children = []
                        }
                        return obj
                      })
                    } else {
                      subItem.children = []
                    }
                    resolve()
                  })
                }
              })
            }

            // 查询四级
            if (level === 3) {
              item.children.forEach(subItem => {
                subItem.children.forEach(thirdChild => {
                  if (thirdChild.id === val[2] && thirdChild.children && thirdChild.children.length === 0) {
                    this.action({ id: val[2], ...this.extraParams }).then(res => {
                      if (this.selectAll) {
                        res.unshift({
                          id: '1',
                          name: '全部'
                        })
                      }
                      thirdChild.children = res || []
                      resolve()
                    })
                  }
                })
              })
            }
          }
        })
      })
    },

    // 完成选择
    handleChange () {
      this.typeChange = false
      this.$emit('change', this.currentValue)
      this.currentLabel = this.$refs['cascader'].getCheckedNodes()[0].pathLabels
    },

    // 初始化一级分类
    initTree () {
      return new Promise((resolve, reject) => {
        if (this.$lodash.isEmpty(this.option)) {
          this.action({ id: 0, ...this.extraParams }).then(res => {
            this.option = res.map(item => { return { ...item, children: [] } })
            resolve()
          })
        } else {
          resolve()
        }
      })
    }

  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      async handler (newVal) {
        this.currentValue = newVal
        // 编辑时初始化分类列表
        await this.initTree()
        if (newVal) {
          this.typeChange = true
          await this.handleItemChange(newVal.slice(0, 1))
          if (this.level > 2) {
            await this.handleItemChange(newVal.slice(0, 2))
          }
          if (this.level > 3) {
            await this.handleItemChange(newVal.slice(0, 3))
          }
        }
        if (this.$refs['cascader']) {
          this.currentLabel = this.$refs['cascader'].getCheckedNodes()[0].pathLabels
        }
      }

    },
    selectAll () {
      this.typeChange = true
    },
    extraParams () {
      this.initTree()
    }
  }

}

</script>
<style scoped>
</style>
